<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">DEFESA COMERCIAL</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <div v-if="imposto.dados.length == 0">
        <ImpostoSemResultado :titulo="imposto.nome" />
      </div>
      <div v-else>
        <RegistrosDefesaComercial
          :imposto="imposto"
          :registroSelecionado="registroSelecionado"
          :selecionouDefesaComercial="selecionouDefesaComercial"
          :seleciona="seleciona"
          :edita="edita"
        />
      </div>
    </QuadroPrincipal>
  </div>
</template>

<script>
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosDefesaComercial from "@/components/RegistrosDefesaComercial/RegistrosDefesaComercial.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "DefesaComercial",

  props: {
    id: String | Number,
    tributoAtivo: String,
    buscarImposto: Function,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    ImpostoSemResultado,
    LoadingResultado,
    MensagemErro,
    MultiplosSemResultado,
    QuadroPrincipal,
    QuadroAlerta,
    RegistrosDefesaComercial
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "DEFESA COMERCIAL",
      nomeImposto: "defesa_comercial",
      imposto: null,
      registroSelecionado: {},
      selecionouDefesaComercial: false,
      erro: false,
      ativarLoading: false
    };
  },

  created() {
    this.setSelecao({
      selecao: { selecionouDefesaComercial: this.selecionouDefesaComercial },
      id: this.id
    });
  },

  updated() {
    if (this.selecionouDefesaComercial) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.ativarLoading = true;
      if (newValue == this.nomeImposto && !this.imposto && this.exibeImposto) {
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
      }
      this.ativarLoading = false;
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouDefesaComercial() {
      this.setSelecao({
        selecao: { selecionouDefesaComercial: this.selecionouDefesaComercial },
        id: this.id
      });
    },

    impressaoLog() {
      let log = {
        logDefesaComercial: {
          imposto: this.registroSelecionado
        }
      };
      return log;
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.registroSelecionado = imposto;
      this.selecionouDefesaComercial = true;
    },

    edita() {
      this.registroSelecionado = {};
      this.selecionouDefesaComercial = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
